// src/components/Footer/index.jsx
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Layout, Typography, Space, Button, message } from 'antd';
import { GithubOutlined, WechatOutlined, QqOutlined } from '@ant-design/icons';
import './index.css';
import { exportPosts, importPosts } from '../../utils/storage';

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;

const AppFooter = () => {
  const fileRef = React.useRef();

  function handleExport() {
    try {
      const posts = exportPosts();
      const blob = new Blob([JSON.stringify(posts, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      const now = new Date();
      const filename = `posts-${now.toISOString().slice(0,10)}.json`;
      a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      message.success('导出成功');
    } catch (err) {
      message.error('导出失败: ' + err.message);
    }
  }

  function handleImportClick() {
    fileRef.current?.click();
  }

  async function handleFileChange(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const text = await file.text();
      const data = JSON.parse(text);
      if (!Array.isArray(data)) { message.error('导入文件格式错误，期待文章数组'); return; }
      const merge = window.confirm(`检测到 ${data.length} 篇文章。点击“确定”将合并到当前文章；点击“取消”将覆盖当前所有文章。`);
      const res = importPosts(data, { merge });
      if (res.ok) {
        message.success(`导入成功，共 ${res.count} 篇文章`);
        // reload to reflect changes
        window.location.reload();
      } else {
        message.error(res.error || '导入失败');
      }
    } catch (err) {
      message.error('解析 JSON 失败：' + err.message);
    } finally {
      e.target.value = '';
    }
  }

  return (
    <AntFooter className="app-footer">
      <div className="footer-inner">
        <div className="footer-left">
          <Text>© 2025 我的博客. All Rights Reserved.</Text>
        </div>

        <div className="footer-center">
          <Space size="large" className="social-links" aria-label="social links">
            <Link href="https://github.com" target="_blank" title="GitHub" aria-label="GitHub">
              <GithubOutlined style={{ fontSize: '20px' }} />
            </Link>
            <Link href="https://weixin.qq.com" target="_blank" title="微信" aria-label="微信">
              <WechatOutlined style={{ fontSize: '20px' }} />
            </Link>
            <Link href="https://im.qq.com" target="_blank" title="QQ" aria-label="QQ">
              <QqOutlined style={{ fontSize: '20px' }} />
            </Link>
          </Space>
        </div>

        <div className="footer-right">
          <RouterLink to="/archive" className="footer-link">归档</RouterLink>
          <Button size="small" className="footer-btn" onClick={handleExport}>导出</Button>
          <Button size="small" className="footer-btn" onClick={handleImportClick}>导入</Button>
          <input
            ref={fileRef}
            type="file"
            accept="application/json"
            className="visually-hidden"
            aria-label="导入文章 JSON 文件"
            onChange={handleFileChange}
          />
        </div>
      </div>

      <Text className="footer-note">Proudly powered by React & Ant Design</Text>
    </AntFooter>
  );
};

export default AppFooter;

